import React from 'react';
import { oneOfType } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Container, variantionsSize } from './tag-international.styles';

function TagInternational({
  variant
}) {
  return /*#__PURE__*/React.createElement(Container, {
    variant: variant,
    "data-testid": "productCard-international-tag",
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "Airplane",
      fill: "#0086FF",
      width: variantionsSize[variant].width,
      height: variantionsSize[variant].height
    })
  }, "Compra Internacional");
}

TagInternational.defaultProps = {
  variant: 'xsmall'
};
process.env.NODE_ENV !== "production" ? TagInternational.propTypes = {
  variant: oneOfType(['xsmall', 'small', 'medium'])
} : void 0;
export default TagInternational;